'use strict';

var React = require('react');
var cs = require('classnames');
require('../../../Box/Box.js');
require('../../../../style-inject.es-dcee06b6.js');
var components_Icon_Icon = require('../../../Icon/Icon.js');
require('../../../../icons/LoaderOutline.js');
var components_Spinner_Spinner = require('../../../Spinner/Spinner.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cs__default = /*#__PURE__*/_interopDefaultLegacy(cs);

/**
 * Render the Button content. It takes the whole Props from parent
 * @param props
 */
const ButtonContent = ({ icon, iconRight, label, hideLabel, showSpinner, }) => {
    const contentInnerClasses = cs__default['default']({
        "ss-button__content-inner ss-flex ss-justify-center ss-items-center": true,
        "ss-opacity-0": showSpinner,
    });
    const labelClasses = cs__default['default']({
        "ss-button__label": true,
        "ss-sr-only": hideLabel,
    });
    return (React__default['default'].createElement("div", { className: "ss-button__content ss-relative" },
        React__default['default'].createElement("div", { className: contentInnerClasses },
            icon && React__default['default'].createElement(components_Icon_Icon, { svg: icon, size: "100%", className: "ss-button__icon ss-w-5 ss-h-5" }),
            React__default['default'].createElement("span", { className: labelClasses }, label),
            iconRight && (React__default['default'].createElement(components_Icon_Icon, { svg: iconRight, size: "100%", className: "ss-button__icon ss-w-5 ss-h-5" }))),
        showSpinner && (React__default['default'].createElement(components_Spinner_Spinner, { isSpinning: showSpinner, size: "100%", className: "ss-button__spinner ss-w-5 ss-h-5 ss-absolute ss-top-0 ss-right-0 ss-bottom-0 ss-left-0 ss-m-auto" }))));
};

module.exports = ButtonContent;
